import { useContext, JSX, useState } from 'react';
import {
    BaseEdge,
    EdgeLabelRenderer,
    getSmoothStepPath,

    useReactFlow,
    EdgeProps
} from '@xyflow/react';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import {
    CircularProgress
} from '@mui/material';

export default function DeleteButtonEdge({
 id,
 source,
 sourceX,
 sourceY,
 targetX,
 targetY,
 sourcePosition,
 targetPosition,
 style = {},
 markerEnd,
}: EdgeProps): JSX.Element {
    const [deleting, setDeleting] = useState<boolean>(false)
    const context = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();
    const [edgePath, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
    });

    const onEdgeClick: () => void = (): void => {
        setDeleting(true);
        let allEdges = reactFlowInstance.getEdges();
        const updatedEdges = allEdges.filter( (edge: any): boolean => edge.id !== id );
        context.updateLayoutEdges(updatedEdges);
        setDeleting(false);
    };
    // While the node upstream of this wire is executing, the wire carries the
    // live signal — that is how you see where the run has got to.
    const isLive: boolean = context?.testProcessing?.includes(source) === true;

    return (
        <>
            <BaseEdge path={edgePath}
                      markerEnd={markerEnd}
                      style={style}
                      className={ isLive ? 'wf-edge-live' : undefined } />
            <EdgeLabelRenderer>
                <div
                    className="button-edge__label nodrag nopan"
                    style={{
                        transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
                    }}
                >
                    <button className="button-edge__button" onClick={onEdgeClick}>
                        { (deleting) &&
                            <CircularProgress size="small" />
                        }
                        { (!deleting) &&
                            <>
                            { '×' }
                            </>
                        }

                    </button>
                </div>
            </EdgeLabelRenderer>
        </>
    );
}

